import axios from "axios";
import AuthService from '../Auth/AuthService';

export default class AnexoChamamentoService extends AuthService {

    findAll() {
        return axios({
            method: 'get',
            url: this.api_url + 'anexo-chamamento',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        }).then(res => res.data);
    }
    findByRegistroId(id) {
        return axios({
            method: 'get',
            url: this.api_url + 'anexo-chamamento/registro/' + id,
            withCredentials: true,
        }).then(res => res.data);
    }
    create(dados) {
        return axios({
            method: 'post',
            url: this.api_url + 'anexo-chamamento',
            data: dados,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
    update(codigo, data) {
        return axios({
            method: 'put',
            url: this.api_url + 'anexo-chamamento/' + codigo,
            data: data,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
    delete(codigo) {
        return axios({
            method: 'delete',
            url: this.api_url + 'anexo-chamamento/' + codigo,
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        });
    }
}
